import React from 'react';

function ContactPage() {
    return (
        <div className="header">
            <h1 style={{fontSize: "50px"}}>Contact</h1>
            <p>Looking forward to hearing from you</p>
            <h2>Phone</h2>
            <p>385-216-8793</p>
            <h2>Email</h2>
            <p>cyan.hch@gmail.com</p>
            <h2>
                <a href="https://www.linkedin.com/in/cyan-hsu/"
                   style={{textDecoration: "none"}}>LinkedIn</a>
            </h2>
            <h2>
                <a href="https://github.com/CyanHsu"
                   style={{textDecoration: "none"}}>GitHub</a>
            </h2>
        </div>
    )
        ;
}

export default ContactPage;